import { Link } from "react-router-dom";

const stats = [
  { value: "12,000+", label: "影视条目" },
  { value: "20+", label: "内容类型" },
  { value: "每日更新", label: "最新推荐" },
];

export default function SiteIntro() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
      <div className="grid grid-cols-1 gap-8 rounded-lg border border-background-200 bg-background-50 p-6 md:grid-cols-2 md:gap-12 md:p-10">
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-3xl">
            关于色色影院
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            色色影院是一个面向广大影视爱好者的内容门户，收录海量电影与电视剧条目，覆盖动作、科幻、悬疑、都市、古装等二十余种类型。我们希望用清晰的信息结构与便捷的筛选方式，帮助你快速了解一部作品、找到想看的内容。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            本站所有影视名称、导演、主演、评分均为虚构演示数据，仅用于展示页面效果，不涉及任何真实作品或版权内容。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
            >
              <i className="ri-information-line text-lg"></i>
              了解更多
            </Link>
            <Link
              to="/about"
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              <i className="ri-mail-line text-lg"></i>
              联系我们
            </Link>
          </div>
        </div>

        <div className="flex flex-col justify-center gap-4">
          <div className="grid grid-cols-3 gap-4">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg bg-secondary-100 px-3 py-4 text-center"
              >
                <p className="font-heading text-base font-bold text-primary-700 md:text-xl">
                  {stat.value}
                </p>
                <p className="mt-1 text-[11px] text-secondary-900 md:text-xs">{stat.label}</p>
              </div>
            ))}
          </div>
          <div className="rounded-lg bg-accent-100 px-5 py-4">
            <p className="flex items-center gap-2 text-sm font-semibold text-accent-900">
              <i className="ri-customer-service-2-line text-lg"></i>
              使用帮助与反馈
            </p>
            <p className="mt-1.5 text-xs leading-relaxed text-accent-900/80">
              如在使用中遇到问题，欢迎通过“关于我们”页面的反馈表单留言，我们会尽快处理你的建议。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}